import React from 'react'
import { Box, Typography, Stack, IconButton } from "@mui/material";
import Config from '../config/config'
import Iconify from './Iconify';

const CartItemResumo = ({ cartItem, removeFromCart, addItemQty, removeItemQty }) => {
    const preco = (parseFloat(cartItem.regular_price) * 0.9).toFixed(2);

    return (
        <Box sx={{ borderBottom: '1px solid #eee', pb: 1.5, mb: 1 }}>
            <Stack direction="row" spacing={1.5} alignItems="flex-start">
                {/* Image */}
                <Box
                    component="img"
                    sx={{
                        width: 56, height: 56, borderRadius: 1,
                        objectFit: 'cover', bgcolor: '#f5f5f5', flexShrink: 0,
                    }}
                    src={cartItem.images?.length > 0
                        ? `${Config.base_fotos}/thumb/${cartItem.produto}_${cartItem.cor_produto}_01.jpg`
                        : 'https://katuxa.sfo3.digitaloceanspaces.com/pdv/sem-imagem.jpg'}
                    alt={cartItem.use_descricao}
                />

                {/* Info */}
                <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
                        <Typography sx={{
                            fontSize: '0.8rem', fontWeight: 600, color: '#222',
                            lineHeight: 1.3, pr: 0.5,
                            overflow: 'hidden', textOverflow: 'ellipsis',
                            display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical',
                        }}>
                            {cartItem.use_descricao}
                        </Typography>
                        <IconButton size="small" onClick={() => removeFromCart(cartItem)} sx={{ color: '#bbb', p: 0.3, '&:hover': { color: '#e53935' } }}>
                            <Iconify width={18} icon="mdi:close" />
                        </IconButton>
                    </Stack>

                    {/* Details row */}
                    <Typography sx={{ fontSize: '0.7rem', color: '#999', mt: 0.5, lineHeight: 1.4 }}>
                        Ref {cartItem.use_referencia} · Tam {cartItem.grade} · Cor {cartItem.use_cod_cor_produto}
                    </Typography>
                    <Typography sx={{ fontSize: '0.7rem', color: '#999' }}>
                        {cartItem.use_cor_produto} · Loja {cartItem.filial}
                    </Typography>

                    {/* Price */}
                    <Typography sx={{ fontSize: '0.85rem', fontWeight: 700, color: '#111', mt: 0.5 }}>
                        R$ {preco}
                    </Typography>
                </Box>
            </Stack>
        </Box>
    )
}

export default CartItemResumo
